var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useRef, useState } from "react";
import classNames from "classnames";
import { QueryBuilder } from "@query-builder/QueryBuilder";
import { ButtonComponent, IconButton, hasValue, SlideInPanel, useToast } from "uxp/components";
import { copyToClipboard } from "@utils";
import './Test.scss';
import initQuery from './query.json';
const Test = props => {
    const queryBuilderRef = useRef(null);
    const [query, setQuery] = useState(null);
    const [hideHeader, setHideHeader] = useState(true);
    const toast = useToast();
    const $L = (key) => props.uxpContext.$L(key);
    const sampleQ1 = {
        "sources": [{
                "source": "collection:DeviceManager/sensors",
                "description": "Contains a list of all IoT sensors. ",
                "enabled": true,
                "fields": [{
                        "name": "id",
                        "type": "",
                        "description": "The sensor id",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }, {
                        "name": "name",
                        "type": "",
                        "description": "",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }, {
                        "name": "type",
                        "type": "",
                        "description": "The sensor type. Can be 'WaterDetect' for water leak sensors or 'TemperatureData' for temperature sensors",
                        "error": null,
                        "example": "",
                        "canSample": true
                    }, {
                        "name": "location",
                        "type": "",
                        "description": "",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }, {
                        "name": "tags",
                        "type": "",
                        "description": "",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }],
                "id": "collection:DeviceManager/sensors",
                "type": "collection",
                "model": "DeviceManager",
                "collection": "sensors",
                "name": "sensors",
                "schema": [{
                        "name": "id",
                        "dataType": "string"
                    }, {
                        "name": "name",
                        "dataType": "string"
                    }, {
                        "name": "type",
                        "dataType": "string"
                    }, {
                        "name": "location",
                        "dataType": "string"
                    }, {
                        "name": "tags",
                        "dataType": "json"
                    }]
            }, {
                "source": "collection:DeviceManager/values",
                "description": "Contains the latest values for each sensor. Values might be stored as strings. You need to convert the value to a number for filtering or aggregation",
                "enabled": true,
                "fields": [{
                        "name": "id",
                        "type": "",
                        "description": "The sensor id",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }, {
                        "name": "value",
                        "type": "string",
                        "description": "The current value of the sensor",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }, {
                        "name": "timestamp",
                        "type": "",
                        "description": "The time at which the last value was recorded",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }],
                "id": "collection:DeviceManager/values",
                "type": "collection",
                "model": "DeviceManager",
                "collection": "values",
                "name": "values",
                "schema": [{
                        "name": "id",
                        "dataType": "string"
                    }, {
                        "name": "value",
                        "dataType": "string"
                    }, {
                        "name": "timestamp",
                        "dataType": "string"
                    }]
            }],
        "steps": [{
                "id": "step1",
                "type": "filter",
                "source": "collection:DeviceManager/sensors",
                "filter": {
                    "$and": [{
                            "type": "WaterDetect"
                        }]
                },
                "name": "step1",
                "schema": [{
                        "name": "id",
                        "dataType": "string"
                    }, {
                        "name": "name",
                        "dataType": "string"
                    }, {
                        "name": "type",
                        "dataType": "string"
                    }, {
                        "name": "location",
                        "dataType": "string"
                    }, {
                        "name": "tags",
                        "dataType": "json"
                    }]
            }, {
                "id": "step2",
                "type": "join",
                "source1": "step1",
                "source2": "collection:DeviceManager/values",
                "on": [{
                        "source1": "id",
                        "source2": "id"
                    }],
                "source2Fields": [{
                        "field": "value",
                        "newField": "sensor_value"
                    }],
                "name": "step2",
                "schema": [{
                        "name": "id",
                        "dataType": "string"
                    }, {
                        "name": "name",
                        "dataType": "string"
                    }, {
                        "name": "type",
                        "dataType": "string"
                    }, {
                        "name": "location",
                        "dataType": "string"
                    }, {
                        "name": "tags",
                        "dataType": "json"
                    }, {
                        "name": "sensor_value"
                    }]
            }, {
                "id": "step3",
                "type": "filter",
                "source": "step2",
                "filter": {
                    "$and": [{
                            "sensor_value": "1"
                        }]
                },
                "name": "step3",
                "schema": [{
                        "name": "id",
                        "dataType": "string"
                    }, {
                        "name": "name",
                        "dataType": "string"
                    }, {
                        "name": "type",
                        "dataType": "string"
                    }, {
                        "name": "location",
                        "dataType": "string"
                    }, {
                        "name": "tags",
                        "dataType": "json"
                    }, {
                        "name": "sensor_value"
                    }]
            }, {
                "id": "step4",
                "type": "aggregate",
                "source": "step3",
                "aggregation": {
                    "fields": [],
                    "aggregates": [{
                            "field": "id",
                            "type": "count",
                            "name": "WaterLeakSensorCount"
                        }]
                },
                "name": "step4",
                "schema": [{
                        "name": "WaterLeakSensorCount",
                        "type": "number"
                    }]
            }]
    };
    const sampleQ2 = {
        "sources": [{
                "source": "collection:DeviceManager/sensors",
                "description": "Contains a list of all IoT sensors. ",
                "enabled": true,
                "fields": [{
                        "name": "id",
                        "type": "",
                        "description": "The sensor id",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }, {
                        "name": "name",
                        "type": "",
                        "description": "",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }, {
                        "name": "type",
                        "type": "",
                        "description": "The sensor type. Can be 'WaterDetect' for water leak sensors or 'TemperatureData' for temperature sensors",
                        "error": null,
                        "example": "",
                        "canSample": true
                    }, {
                        "name": "location",
                        "type": "",
                        "description": "",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }, {
                        "name": "tags",
                        "type": "",
                        "description": "",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }],
                "id": "collection:DeviceManager/sensors",
                "type": "collection",
                "model": "DeviceManager",
                "collection": "sensors",
                "name": "sensors",
                "schema": [{
                        "name": "id",
                        "dataType": "string"
                    }, {
                        "name": "name",
                        "dataType": "string"
                    }, {
                        "name": "type",
                        "dataType": "string"
                    }, {
                        "name": "location",
                        "dataType": "string"
                    }, {
                        "name": "tags",
                        "dataType": "json"
                    }]
            }],
        "steps": [{
                "id": "step1",
                "type": "filter",
                "source": "collection:DeviceManager/sensors",
                "filter": {
                    "$and": [{
                            "type": {
                                "$in": ["WaterDetect"]
                            }
                        }]
                },
                "name": "step1",
                "schema": [{
                        "name": "id",
                        "dataType": "string"
                    }, {
                        "name": "name",
                        "dataType": "string"
                    }, {
                        "name": "type",
                        "dataType": "string"
                    }, {
                        "name": "location",
                        "dataType": "string"
                    }, {
                        "name": "tags",
                        "dataType": "json"
                    }]
            }, {
                "id": "aggregate-1721301632523",
                "name": "AGGREGATE",
                "schema": [{
                        "name": "id",
                        "type": "number"
                    }],
                "type": "aggregate",
                "source": "step1",
                "aggregation": {
                    "fields": [],
                    "aggregates": [{
                            "field": "id",
                            "type": "count",
                            "name": null
                        }]
                }
            }]
    };
    const sampleQ3 = {
        "sources": [{
                "source": "collection:DeviceManager/values",
                "description": "Contains the latest values for each sensor. Values might be stored as strings. You need to convert the value to a number for filtering or aggregation",
                "enabled": true,
                "fields": [{
                        "name": "id",
                        "type": "",
                        "description": "The sensor id",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }, {
                        "name": "value",
                        "type": "string",
                        "description": "The current value of the sensor",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }, {
                        "name": "timestamp",
                        "type": "",
                        "description": "The time at which the last value was recorded",
                        "error": null,
                        "example": "",
                        "canSample": false
                    }],
                "id": "collection:DeviceManager/values",
                "type": "collection",
                "model": "DeviceManager",
                "collection": "values",
                "name": "values",
                "schema": [{
                        "name": "id",
                        "dataType": "string"
                    }, {
                        "name": "value",
                        "dataType": "string"
                    }, {
                        "name": "timestamp",
                        "dataType": "string"
                    }]
            }],
        "steps": [{
                "id": "custom-transform-1720632075820",
                "type": "custom-transform",
                "name": "CUSTOM-TRANSFORM",
                "source": "collection:DeviceManager/values",
                "description": "Add a new field that has the number of hours since the 'timestamp' field",
                "code": "function transform(row) {\n row['HoursSince'] = (Date.now() - parseAnyDate(row['timestamp']).getTime()) / 3600000;\n return row;\n }",
                "added": ["HoursSince"],
                "removed": [],
                "schema": [{
                        "name": "id",
                        "dataType": "string"
                    }, {
                        "name": "value",
                        "dataType": "string"
                    }, {
                        "name": "timestamp",
                        "dataType": "string"
                    }, {
                        "name": "HoursSince",
                        "type": "string"
                    }]
            }, {
                "id": "filter-1720632119234",
                "type": "filter",
                "name": "FILTER",
                "source": "custom-transform-1720632075820",
                "filter": {
                    "$and": [{
                            "HoursSince": {
                                "$gt": "24"
                            }
                        }]
                },
                "schema": [{
                        "name": "id",
                        "dataType": "string"
                    }, {
                        "name": "value",
                        "dataType": "string"
                    }, {
                        "name": "timestamp",
                        "dataType": "string"
                    }, {
                        "name": "HoursSince",
                        "type": "string"
                    }]
            }, {
                "id": "aggregate-1720632169688",
                "type": "aggregate",
                "name": "AGGREGATE",
                "source": "filter-1720632119234",
                "aggregation": {
                    "fields": [],
                    "aggregates": [{
                            "field": "id",
                            "type": "count",
                            "name": null
                        }]
                },
                "schema": [{
                        "name": "id",
                        "type": "number"
                    }]
            }]
    };
    const sampleQ4 = {
        "sources": [{
                "source": "collection:DeviceManager/sensors",
                "description": "Contains a list of all IoT sensors. ",
                "enabled": true,
                "fields": [{
                        "name": "id",
                        "type": "",
                        "description": "The sensor id",
                        "error": null,
                        "example": "",
                        "canSample": false,
                        "historicalData": null
                    }, {
                        "name": "name",
                        "type": "",
                        "description": "",
                        "error": null,
                        "example": "",
                        "canSample": false,
                        "historicalData": null
                    }, {
                        "name": "type",
                        "type": "",
                        "description": "The sensor type. Can be 'WaterDetect' for water leak sensors or 'TemperatureData' for temperature sensors",
                        "error": null,
                        "example": "",
                        "canSample": true,
                        "historicalData": null
                    }, {
                        "name": "location",
                        "type": "",
                        "description": "",
                        "error": null,
                        "example": "",
                        "canSample": false,
                        "historicalData": null
                    }, {
                        "name": "tags",
                        "type": "",
                        "description": "",
                        "error": null,
                        "example": "",
                        "canSample": false,
                        "historicalData": null
                    }],
                "id": "collection:DeviceManager/sensors",
                "type": "collection",
                "model": "DeviceManager",
                "collection": "sensors",
                "name": "sensors",
                "schema": [{
                        "name": "id",
                        "dataType": "string"
                    }, {
                        "name": "name",
                        "dataType": "string"
                    }, {
                        "name": "type",
                        "dataType": "string"
                    }, {
                        "name": "location",
                        "dataType": "string"
                    }, {
                        "name": "tags",
                        "dataType": "json"
                    }]
            }],
        "steps": [{
                "id": "aggregate-1722335735975",
                "name": "AGGREGATE",
                "schema": [{
                        "name": "type",
                        "dataType": "string"
                    }, {
                        "name": "id",
                        "type": "number"
                    }],
                "type": "aggregate",
                "source": "collection:DeviceManager/sensors",
                "aggregation": {
                    "fields": ["type"],
                    "aggregates": [{
                            "field": "id",
                            "type": "count",
                            "name": null
                        }]
                }
            }]
    };
    return React.createElement("div", { className: classNames("lqe-sa-694bd098", {
            "lqe-sa--no-hd-694bd098": hideHeader
        }) },
        !hideHeader ? React.createElement("div", { className: "lqe-sa__hd-694bd098" },
            React.createElement("div", { className: "lqe-sa__hd-title-694bd098" }, $L('lqe.test.title')),
            React.createElement("div", { className: "lqe-sa__hd-actions-694bd098" },
                React.createElement(ButtonComponent, { title: $L('lqe.test.cancel'), onClick: () => { var _a; return (_a = queryBuilderRef === null || queryBuilderRef === void 0 ? void 0 : queryBuilderRef.current) === null || _a === void 0 ? void 0 : _a.onCancel(); }, leftIcon: "fas times", variant: "secondary" }),
                React.createElement(ButtonComponent, { title: $L('lqe.test.save'), onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        var _a;
                        const { isValid, query: _query, error } = yield ((_a = queryBuilderRef === null || queryBuilderRef === void 0 ? void 0 : queryBuilderRef.current) === null || _a === void 0 ? void 0 : _a.onSave());
                        setQuery(isValid ? _query : null);
                        if (hasValue(error))
                            alert(error);
                    }), leftIcon: "fas save", variant: "primary" }))) : null,
        React.createElement("div", { className: "lqe-sa__body-694bd098" },
            React.createElement(QueryBuilder, { uxpContext: props.uxpContext, ref: queryBuilderRef, initialQuery: initQuery || null, onChangeView: (view) => setHideHeader(view == 'home') })),
        React.createElement(SlideInPanel, { isOpen: !!query, onClose: () => setQuery(null), direction: "right" },
            React.createElement("div", { className: "test-query-preview-694bd098" },
                React.createElement("div", { className: "test-query-preview__hd-694bd098" },
                    React.createElement("div", { className: "test-query-preview__title-694bd098" }, $L('lqe.test.query')),
                    React.createElement(IconButton, { type: "close", onClick: () => setQuery(null) })),
                React.createElement("div", { className: "test-query-preview__body-694bd098" },
                    React.createElement("code", null,
                        React.createElement("pre", null, JSON.stringify(query, null, 4)))),
                React.createElement("div", { className: "test-query-preview__ft-694bd098" },
                    React.createElement(ButtonComponent, { title: $L('lqe.test.copy'), onClick: () => {
                            copyToClipboard(JSON.stringify(query, null, 4));
                            toast.info($L('lqe.test.copied'));
                        }, leftIcon: "fas copy", variant: "secondary" })))));
};
export default Test;
